import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Field from 'lib/struct/form/fields/Field';

import GroupSettingsForm from './GroupSettingsForm';

import c_styles from '../ProductGroupsSettingsComponent.less';

@observer export default class GroupsSettingsComponent extends Component {
	handleSave = () => {
		const { context } = this.props;
		context.save();
	};

	render() {
		/** @type {ProductGroupsSettingsContext} */
		const context = this.props.context;

		return (
			<div>
				{
					context.product_groups.map(product_group => (
						<Field
							label='Группа'
							key={product_group._key}
							labelClassName={c_styles['field-label']}
							boxClassName={c_styles['field-box']}
						>
							<GroupSettingsForm
								context={context}
								product_group={product_group}
							/>
						</Field>
					))
				}


				{window.shop_productgroup_ui_version == '2.0' && (
					<div className={c_styles['save-button-container']}>
						<button onClick={this.handleSave} className="btn btn-primary custom-my-32" disabled={context.is_saving}>
							Сохранить
						</button>

						{context.is_saving && (
							<span className={c_styles['loading']}>
								<i className="custom-ml-8 fas fa-spinner wa-animation-spin"></i> Загрузка...
							</span>
						)}
						{context.save_success && (
							<span className={c_styles['success']}>
								<i className="custom-ml-8 fas fa-check"></i> Сохранено
							</span>
						)}
						{context.save_error && (
							<span className={c_styles['error']}>
								<i className="custom-ml-8 fas fa-times"></i> Ошибка
							</span>
						)}
					</div>
				)}
			</div>
		);
	}
}